import type React from 'react';

import type { FieldRenderProps } from '@/js/libs/final-form';
import type { CustomToolbarItem } from '@/js/libs/ui/src/V2';
import { RichTextEditor as V2RichTextEditor } from '@/js/libs/ui/src/V2';

interface RteFieldProps
  extends FieldRenderProps<string | undefined, HTMLInputElement>,
    Omit<React.HTMLProps<HTMLInputElement>, 'as' | 'ref' | 'css'> {
  placeholders?: string[];
  withPreviewToggle?: boolean;
  readOnly?: boolean;
  additionalToolbarItems?: CustomToolbarItem[];
}

const RteField: React.FC<RteFieldProps> = ({
  rows,
  input,
  placeholders,
  withPreviewToggle,
  readOnly,
  disabled,
  additionalToolbarItems,
}) => (
  <V2RichTextEditor
    value={input.value}
    onChange={input.onChange}
    placeholders={placeholders}
    withPreviewToggle={withPreviewToggle}
    readOnly={readOnly}
    disabled={disabled}
    additionalToolbarItems={additionalToolbarItems}
    rows={rows}
    dataTestId={`${input.name}-field`}
  />
);

export default RteField;
